import { render, staticRenderFns } from "./SubscriptionplanDetails.vue?vue&type=template&id=63e3071c&scoped=true&"
import script from "./SubscriptionplanDetails.vue?vue&type=script&lang=js&"
export * from "./SubscriptionplanDetails.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionplanDetails.vue?vue&type=style&index=0&id=63e3071c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e3071c",
  null
  
)

export default component.exports